import React from "react";
import { Box, Typography, Alert, AlertTitle } from "@mui/material";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

const NotAllow = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="70vh"
      px={2}
    >
      <Alert severity="error" icon={<ReportProblemIcon fontSize="inherit" />}>
        <AlertTitle>Acceso denegado</AlertTitle>
        No tenés permisos para acceder a esta sección.
      </Alert>

      <Typography variant="body2" color="textSecondary" mt={2}>
        Si creés que esto es un error, comunicate con el administrador del
        sistema.
      </Typography>
    </Box>
  );
};

export default NotAllow;
